import request from '../untils/request';

export const operationRefundCouponApi = params => {
  return request({
    url: '/operation/refund-coupon/index',
    authCode: 'REFUND-COUPON_INDEX',
    params,
  });
};

export const operationRefundCouponOperateApi = params => {
  return request({
    url: '/operation/refund-coupon/operate',
    authCode: 'REFUND-COUPON_INDEX',
    params,
  });
};
export const operationRefundCouponSendApi = params => {
  return request({
    url: '/operation/refund-coupon/send',
    authCode: 'REFUND-COUPON_INDEX',
    params,
  });
};

export const operationRefundCouponSendListApi = params => {
  return request({
    url: '/operation/refund-coupon/send-list',
    authCode: 'REFUND-COUPON_INDEX',
    params,
  });
};

export const operationRefundCouponcreateApi = params => {
  return request({
    url: '/operation/refund-coupon/create',
    authCode: 'REFUND-COUPON_INDEX',
    params,
  });
};
